export const TechnicianStatus = {
  NOT_RELEASED: { value: 1, label: 'NÃO LIBERADO' },
  RELEASED: { value: 2, label: 'LIBERADO' },
  WITHOUT_REPAIR: { value: 3, label: 'SEM REPARO' },
  AWAITING_PARTS: { value: 4, label: 'AGUARDANDO PEÇAS' },
  INTERNAL_USE: { value: 5, label: 'USO INTERNO' },
  WARRANTY: { value: 6, label: 'GARANTIA' },
  ASSESSMENT: { value: 7, label: 'LAUDO' },
}
